import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import axiosInstance from "../../axiosInstance"; // Import axiosInstance
import "./download-app.css";
import ThinFooter from "../Footer/ThinFooter"; // Import the footer component

const version = '0.0.3';
const DownLoadApp = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [rowId, setRowId] = useState("");
  const [error, setError] = useState("");

  // Fetch User Details (UUID & First Name)
  useEffect(() => {
    const fetchUserDetails = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setError("Unauthorized: No token found.");
        console.error("Unauthorized: No token found.");
        return;
      }

      try {
        console.log("Requesting user details with token:", token);

        const response = await axiosInstance.get("/users/currentUser", {
          headers: {
            Authorization: token,
          },
        });

        console.log("API Response:", response.data);

        if (response.data?.success && response.data?.data?.user) {
          const user = response.data.data.user;
          setRowId(user.id);
          setFirstName(user.firstName);
          setLastName(user.lastName);
        } else {
          console.error("User details not found in response:", response.data);
          setError("User details not found in API response.");
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setError("Failed to fetch user details. Please try again.");

        if (error.response?.status === 401) {
          alert("Unauthorized access. Please log in again.");
        } else if (error.response?.status === 404) {
          alert("User API not found (404). Please check the endpoint.");
        } else {
          alert("An error occurred while fetching user details. Please try again.");
        }
      }
    };

    fetchUserDetails();
  }, []);

  const createAndDownloadOTRCFile = () => {
    if (!rowId || !firstName) {
      alert("User details not available. Please try again.");
      return;
    }

    const content = `{
      "_type": "configuration",
      "_id": "unique-configuration-id",
      "waypoints": [],
      "_build": "420500014",
      "autostartOnBoot": true,
      "cmd": true,
      "connectionTimeoutSeconds": 30,
      "debugLog": false,
      "deviceId": "${firstName}_${lastName}_${rowId}_${version}",
      "dontReuseHttpClient": false,
      "enableMapRotation": true,
      "encryptionKey": "",
      "experimentalFeatures": [],
      "extendedData": true,
      "fusedRegionDetection": true,
      "ignoreInaccurateLocations": 50,
      "ignoreStaleLocations": 0.0,
      "locatorDisplacement": 50,
      "locatorInterval": 30,
      "mapLayerStyle": "GoogleMapDefault",
      "mode": 3,
      "monitoring": 2,
      "moveModeLocatorInterval": 1,
      "notificationEvents": true,
      "notificationGeocoderErrors": true,
      "notificationHigherPriority": false,
      "notificationLocation": true,
      "opencageApiKey": "",
      "osmTileScaleFactor": 1.0,
      "password": "",
      "pegLocatorFastestIntervalToInterval": false,
      "ping": 15,
      "port": 6001,
      "pubQos": 1,
      "pubRetain": true,
      "pubTopicBase": "owntracks/%u/%d",
      "publishLocationOnConnect": true,
      "remoteConfiguration": false,
      "reverseGeocodeProvider": "Device",
      "showRegionsOnMap": false,
      "sub": true,
      "subQos": 2,
      "subTopic": "owntracks/+/+",
      "theme": 2,
      "tid": "ID",
      "tls": false,
      "tlsClientCrt": "",
      "url": "https://dj1shpamki.execute-api.us-east-2.amazonaws.com/prod/post_data",
      "username": "${firstName} ${lastName}",
      "version": "${version}"
    }`;

    // Set file name using first name (fallback to "User" if empty)
    const currentDate = new Date();
    const timestamp = currentDate.toISOString().replace(/[:.-]/g, '');
    const fileName = `${firstName?.replace(' ', '_') || "User"}_config${timestamp}.otrc`;

    // download
    const blob = new Blob([content], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <ContentWrapper>
      <Container fluid className="download-app-container pb-0">
        <Breadcrumb>
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Download App</Breadcrumb.Item>
        </Breadcrumb>

        <Row className="justify-content-center text-center">
          <Col md={8} className="appstion_s">
            {/* Step 1: Download Section */}
            <h4 className="step-title">Step 1: Download OwnTracks App</h4>
            <div className="download-buttons">
              <a href="https://apps.apple.com/us/app/owntracks/id692424691" target="_blank" rel="noopener noreferrer">
                <Button variant="danger" className="download-btn">iOS</Button>
              </a>
              <a href="https://play.google.com/store/apps/details?id=org.owntracks.android" target="_blank" rel="noopener noreferrer">
                <Button variant="danger" className="download-btn">Android</Button>
              </a>
            </div>

            {/* Step 2: Update Section */}
            <h4 className="step-title step-confg">Step 2: Configure Settings</h4>
            <Button variant="danger" className="update-btn" onClick={createAndDownloadOTRCFile}>
              Download
            </Button>

            {/* Display Errors if Any */}
            {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}

            {/* Notice */}
            <p className="download-notice">
              This update is unique to your car, do not share it with other <br />
              drivers, or have it on multiple phones at the same time.
            </p>

            {/* Step-by-Step Registration PDF Link */}
            <p className="step-registration">
              <a href="/pdf/autotrak_Registration.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link">
                Step-by-Step Registration PDF
                <i className="bi bi-box-arrow-up-right"></i>
              </a>
            </p>
            {/* Embedded Videos */}
            <div className="video-container">
              <iframe
                width="100%"
                height="260px"
                src="https://www.youtube.com/embed/5ZXe0-tT7Ys"
                title="autotrak.ai - Android setup"
                frameBorder="0"
                allowFullScreen
              ></iframe>

              <iframe
                width="100%"
                height="260px"
                src="https://www.youtube.com/embed/gIwUQQAnUQs"
                title="autotrak.ai - iPhone setup"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>

          </Col>
        </Row>
      </Container>
       <ThinFooter /> {/* Add Footer here */}
    </ContentWrapper>
  );

};

export default DownLoadApp;
